import Grid from "components/primitives/Grid";
import Constants from "config/Constants";
import { useTranslation } from "react-i18next";
import { Page, PageHeaderActions, PageTitle } from "components/Layout";
import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";
import MuiThemeProvider from "components/MuiThemeProvider";
import AthleteTableInfoCardAdornment from "./AthleteTableInfoCardAdornment";
import AthleteTable from "../AthleteTable";
import AthleteTableControls from "../AthleteTable/AthleteTableControls";
import HeaderActions from "./HeaderActions";

function AthleteHubContent() {
  const { t } = useTranslation();
  return (
    <ThemeProvider2024>
      <Page
        header={
          <>
            <PageTitle endAdornment={<AthleteTableInfoCardAdornment />}>
              {t(Constants.routes.athletes.titleKey)}
            </PageTitle>
            <PageHeaderActions>
              <HeaderActions />
            </PageHeaderActions>
          </>
        }
      >
        <MuiThemeProvider>
          <Grid container width="100%" height="100%">
            <Grid width="100%" height="100%">
              <AthleteTable TableControlsComponent={AthleteTableControls} />
            </Grid>
          </Grid>
        </MuiThemeProvider>
      </Page>
    </ThemeProvider2024>
  );
}

export default AthleteHubContent;
